// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {SvgIconEl} from 'common/components/svg-icon';

import type {ButtonBar} from './index';

export function template(this: ButtonBar) {
  return (
    <div
      sel='.mp-button-bar-container'
      class={{
        [`mp-button-bar-${this.attr(`theme`)}`]: true,
        'mp-button-bar-is-disabled': this.attr(`disabled`),
      }}
      attrs={{elref: `buttonBarContainer`}}
    >
      <div sel='.mp-button-bar-content-wrapper'>
        <div sel='.mp-button-bar-content'>
          <slot />
        </div>
        {this.attr(`arrow-next`) ? (
          <div sel='.mp-button-bar-arrow-next'>
            <SvgIconEl attrs={{icon: `arrow-right`}} />
          </div>
        ) : null}
      </div>
    </div>
  );
}
